export var insertAt = function (text, toInsert, start, end) {
    if (end === void 0) { end = start; }
    return text.slice(0, start) + toInsert + text.slice(end);
};
export var padLeftZeros = function (value, length) {
    while (value.length < length) {
        value = "0" + value;
    }
    return value;
};
//# sourceMappingURL=strings.js.map